import { NumberInput } from '@library/components/inputs';
import { classNames } from '@library/utils';

export interface RankInputCellProps {
  className?: string;
  disabled?: boolean;
  handleProjectionRankChange: (newRank?: number | null) => void;
  initialRank?: number | null;
  projectionId: string;
  rank?: number | null;
}

export const RankInputCell = ({
  className = '',
  disabled = false,
  handleProjectionRankChange,
  initialRank = undefined,
  projectionId,
  rank = undefined
}: RankInputCellProps) => {
  const isRankChanged = initialRank !== rank;

  return (
    <td className={className || 'flex justify-center p-4'}>
      <NumberInput
        className={classNames(
          'focus:border-msJackson bg-soFresh-120 border-soFresh-140 text-soClean-100 h-8 w-12 justify-center rounded-md p-0 text-center text-sm font-medium leading-5 tracking-tight',
          isRankChanged ? '!border-msJackson' : ''
        )}
        disabled={disabled}
        id={`${projectionId}-rank-input`}
        onValueChange={(newValue: string) => {
          handleProjectionRankChange(
            newValue.length > 0 ? Number(newValue) : undefined
          );
        }}
        value={String(rank)}
      />
    </td>
  );
};
